class anchorManager extends HTMLElement {
  constructor() {
    super();

    this.container = this;

    this.initActions();
  }
  initActions() {
    this.container.querySelectorAll('[data-anchor-link]').forEach((button) => {
      const anchorId = button.getAttribute('data-anchor-link');

      button.addEventListener("click", () => {
        const anchor = document.querySelector(anchorId);
        const headerOffset = 80;
        const elementPosition = anchor.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      })
    });
  }
}

customElements.define("anchor-manager", anchorManager);